import { BasicObstacle, ObstacleType, eBasicObstacleFlag, ObstacleTypeShadow } from "./Obstacle";
import { eBonusUID, BONUSES } from "../Bonuses/Bonus";
import { TIMER } from "../Gameplay";
import { ModelUtils } from "../../Utils/ModelUtils";
import { BonusManager } from "../Bonuses/BonusManager";
import { Character } from "../Player/Character";
import { eModelAsset, eSfxSprite } from "../../Game";
import { SoundManager } from "../../Utils/SoundManager";


export const enum eBonusFlag {
    pickupFx = 0x1000
}



export class Bonus extends BasicObstacle {
    /**
     * Cas sebrani bonusu
     */
    protected _pickupTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (!super.update())
            return false;

        // Rotace na ose Y
        this._entity.rotateLocal(0, 360 * TIMER.deltaS, 0);

        // Efekt sebrani
        if ((this._flags & eBonusFlag.pickupFx) != 0) {
            let progress = (TIMER.time - this._pickupTime) / 750;

            if (progress >= 1) {
                this.reset();
                return false;
            }

            // Pozice
            let pos = this._entity.getLocalPosition();

            pos.y = this._type.y + 1 * pc.CubicOut(progress);
            this._entity.setLocalPosition(pos);

            // Alfa
            if (progress > 0.5)
                ModelUtils.setOpacity(this._entity.model, 1 - pc.CubicOut((progress - 0.5) / 0.5));
        }

        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    handlePlCollision(plChar: Character): void {
        if ((this._flags & eBonusFlag.pickupFx) == 0) {
            this._flags &= ~eBasicObstacleFlag.checkCollision;
            this._flags |= eBonusFlag.pickupFx;

            this._pickupTime = TIMER.time;

            // Odebrat model z batchGroup jelikoz u nej budeme menit opacity materialu
            this._entity.model.batchGroupId = -1;
            this._entity.model.castShadows = false;
            this._entity.model.meshInstances.forEach((mesh: pc.MeshInstance, i: number) => {
                mesh.material = this._type.meshMat2[i];
            });
            ModelUtils.setOpacity(this._entity.model, 1);

            // Skryt stin
            if (this._shadow)
                this._shadow.element.enabled = false;

            // Aktivovat bonus
            BonusManager.instance.activateBonus(BONUSES[this._type.uid]);

            // Audio
            SoundManager.playSound(plChar.player.soundComponent, eSfxSprite.bonusPickup);
        }
    }
}



const bonusShadow = new ObstacleTypeShadow("shadowBonus", new pc.Vec2(0.35, 0.17), [new pc.Vec3(0, 0.01, 0)]);



/**
 * Seznam s typy prekazek pro silnici
 */
export const BONUS_TYPES: ObstacleType[] = [
    new ObstacleType(eBonusUID.shield, eModelAsset.bonusShield, 0, 0.2, new pc.Vec2(0.2, 0.2), new pc.Vec2(0, 0), bonusShadow),
    new ObstacleType(eBonusUID.scoreMultiplier, eModelAsset.bonus2x, 0, 0.2, new pc.Vec2(0.2, 0.2), new pc.Vec2(0, 0), bonusShadow),
];